module.exports = __webpack_public_path__ + "static/blue-rocket-hand-120b0d8f96eb56f655d8032b839d7a0a.png";